"use client"
import { notFound } from "next/navigation";
import { memo } from "react";
import OverlayTransitionWrapper from "@/components/overlay-transition-wrapper/overlay-transition-wrapper";
import { themes } from "@/constants/themes";
import { useApp } from "@/context/AppContext"
import { categories as dummyCategories } from "@/data/dummy-data";
import RecordsGalleryPage from "../records-gallery/records-gallery-page";
import RecordStoryLayout from "../records-story-layout/records-story-layout";

function RecordStoryPage({
  featuredStories,
  curatedStories,
  allStories,
  category,
  slug
}) {
  const { recordCategoryType } = useApp();
  let storiesAPI;

  switch (recordCategoryType) {
  case 'all':
    storiesAPI = allStories;
    break;
  case 'featured':
    storiesAPI = featuredStories;
    break
  case 'curated':
    storiesAPI = curatedStories;
    break;
  default:
    storiesAPI = curatedStories;
  }

  const stories = storiesAPI;
  const story = stories.find(s => s.slug === slug);
  const theme = themes.find(theme => theme.categorySlug === category.slug)?.name ?? 'main-dark';

  const catId = 'featured'

  if (!story) {
    notFound()
  }

  return (
    <OverlayTransitionWrapper
      backgroundContent={
        <RecordsGalleryPage
          catId={catId}
          introCategory={dummyCategories.find(c => c.slug === catId)}
          allCards={allStories}
          introCards={featuredStories}
          isDummy={true}
        />
      }
      overlayContent={
        <RecordStoryLayout
          category={category}
          story={story}
          stories={stories}
          theme={theme}
        />
      }
      mainContent={
        <div className="w-full font-sans page">
          <RecordStoryLayout
            category={category}
            story={story}
            stories={stories}
            theme={theme}
          />
        </div>
      }
    />
  )
}

export default memo(RecordStoryPage)